/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactcodeurl2Inputs */

const en_entity_contactcodeurl2 = /** @type {(inputs: Entity_Contactcodeurl2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code URL`)
};

const de_entity_contactcodeurl2 = /** @type {(inputs: Entity_Contactcodeurl2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-URL`)
};

/**
* | output |
* | --- |
* | "Contact Code URL" |
*
* @param {Entity_Contactcodeurl2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactcodeurl2 = /** @type {((inputs?: Entity_Contactcodeurl2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactcodeurl2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactcodeurl2(inputs)
	return de_entity_contactcodeurl2(inputs)
});
export { entity_contactcodeurl2 as "entity_contactCodeUrl" }